/* ============================================================
   CHAOS Variant Compare — runtime enhancements.

   1. "Highlight differences" toggle. Each row is tagged with
      data-equal="true" if every variant cell renders the same
      text. Clicking the toggle tints rows where the variants
      differ via the .cf-cmp__table--diff-highlight class.

   2. Per-column Add to cart wiring. The Liquid renders one
      <form> per available variant; this handler intercepts the
      submit and posts /cart/add.js via fetch so the header
      cart-badge interceptor in nav-hover-panel.js refreshes.

   Self-initialising; targets all .cf-cmp instances on the page.
   ============================================================ */
(function () {
  function init(section) {
    const table = section.querySelector('.cf-cmp__table');
    if (!table) return;

    // --- 1. Per-row equal/different detection + toggle wiring ---
    // A row is "equal" when every variant's cell text matches; CSS uses
    // data-equal="false" to tint the whole row (spec label + cells) when
    // the toggle is on, and skips equal rows entirely so labels like
    // "BEARINGS" / "HAND" / "SPOOL MATERIAL" stay clean.
    const rows = table.querySelectorAll('tbody tr');
    rows.forEach((row) => {
      const cells = row.querySelectorAll('.cf-cmp__cell');
      if (cells.length < 2) {
        row.dataset.equal = 'true';
        return;
      }
      const first = cells[0].textContent.trim();
      let allEqual = true;
      for (let i = 1; i < cells.length; i++) {
        if (cells[i].textContent.trim() !== first) {
          allEqual = false;
          break;
        }
      }
      row.dataset.equal = allEqual ? 'true' : 'false';
    });

    const toggle = section.querySelector('[data-cmp-diff-toggle]');
    if (!toggle) return;

    // If every row is equal, the toggle would be a no-op — hide it.
    const anyDiff = Array.from(rows).some((r) => r.dataset.equal === 'false');
    if (!anyDiff) {
      toggle.hidden = true;
      return;
    }

    toggle.addEventListener('click', () => {
      const next = toggle.getAttribute('aria-pressed') !== 'true';
      toggle.setAttribute('aria-pressed', String(next));
      table.classList.toggle('cf-cmp__table--diff-highlight', next);
    });
  }

  // --- 2. Per-column Add to cart wiring ---
  // Submits the variant ID via fetch so the header cart-badge interceptor
  // in nav-hover-panel.js picks it up. Falls back to native form post on
  // any network error so the user still gets to the cart.
  function wireAddToCart(section) {
    section.querySelectorAll('[data-cmp-atc-form]').forEach((form) => {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const btn = form.querySelector('.cf-cmp__col-atc');
        if (!btn || btn.disabled) return;
        const original = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/javascript' },
          });
          if (!res.ok) throw new Error('cart add failed');
          btn.textContent = 'Added';
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer.open === 'function') drawer.open();
          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        } catch (err) {
          btn.textContent = 'Try again';
          setTimeout(() => {
            btn.textContent = original;
            btn.disabled = false;
          }, 1500);
        }
      });
    });
  }

  function bootstrap() {
    document.querySelectorAll('.cf-cmp').forEach((section) => {
      init(section);
      wireAddToCart(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
})();
